module.exports = __webpack_public_path__ + "static/media/spaceships_dark_alt.6cdeabdc.svg";